const interval = 60000; // 60000 1 minute -  30.0000 5 minutes
const data_length = 60;

const chart_data = {
  l1_rms: Array.from({ length: data_length }, () => Math.random() * 100 + 150),
  l2_rms: Array.from({ length: data_length }, () => Math.random() * 100 + 150),
  l3_rms: Array.from({ length: data_length }, () => Math.random() * 100 + 150),

  l1_power_active: Array.from({ length: data_length }, () => Math.random() * 50 + 50),
  l2_power_active: Array.from({ length: data_length }, () => Math.random() * 50 + 50),
  l3_power_active: Array.from({ length: data_length }, () => Math.random() * 50 + 50),

  l1_power_reactive: Array.from({ length: data_length }, () => Math.random() * 50 + 50),
  l2_power_reactive: Array.from({ length: data_length }, () => Math.random() * 50 + 50),
  l3_power_reactive: Array.from({ length: data_length }, () => Math.random() * 50 + 50),

  l1_apparent_power: Array.from({ length: data_length }, () => Math.random() * 50 + 50),
  l2_apparent_power: Array.from({ length: data_length }, () => Math.random() * 50 + 50),
  l3_apparent_power: Array.from({ length: data_length }, () => Math.random() * 50 + 50),

  l1_temperature: Array.from({ length: data_length }, () => Math.random() * 10 + 20),
  l2_temperature: Array.from({ length: data_length }, () => Math.random() * 10 + 20),
  l3_temperature: Array.from({ length: data_length }, () => Math.random() * 10 + 20),

  timestamps: Array.from({ length: data_length }, (_, i) => 1727262180000 + i * interval),
};

export default chart_data;
